const multiFieldTypes = [304];

function isMultiField(type) {
    return multiFieldTypes.includes(type);
}

export default isMultiField;
